var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { GlobalContext } from "@/contexts/GlobalContext";
import { UserTrackingFlow } from "@/types/ApplyFlowParameters";
import { memo, useContext } from "react";
var ImpressionPixelComponent = function (_a) {
    var type = _a.type, jobKey = _a.jobKey, impressionUrl = _a.impressionUrl;
    var _b = useContext(GlobalContext), applyFlowParameters = _b.applyFlowParameters, properties = _b.properties;
    var pixelStyle = {
        display: "block",
        marginBottom: "-1px",
    };
    var renderPixel = function () {
        var useCareerSites = (applyFlowParameters === null || applyFlowParameters === void 0 ? void 0 : applyFlowParameters.userTrackingFlow) === UserTrackingFlow.CAREER_SITES;
        if (!impressionUrl && !useCareerSites)
            return _jsx(_Fragment, {});
        var pixelClass = type.toString();
        var pixelProps = useCareerSites
            ? {
                "data-jk": jobKey,
                "data-tk": properties.placementId
                    ? "".concat(jobKey, "-").concat(properties.placementId)
                    : jobKey,
            }
            : { "data-src": impressionUrl };
        return (_jsx("img", __assign({ className: pixelClass }, pixelProps, { width: 1, height: 1, style: pixelStyle, alt: "", tabIndex: -1, "aria-hidden": true })));
    };
    return renderPixel();
};
export var ImpressionPixel = memo(ImpressionPixelComponent);
